import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    width: "100%",
    marginBottom: theme.spacing(1),
  },
  label: {
    width: "auto",
    minWidth: theme.spacing(10),
    fontSize: "0.625rem",
    textTransform: "capitalize",
  },
  bars: {
    flex: 1,
    display: "flex",
    gap: theme.spacing(0.5),
  },
  bar: {
    width: "1.25rem",
    height: "5px",
    borderRadius: "3px",
    backgroundColor: "#e0e0e0",
  },
  textVariant: {
    backgroundColor: "#933a3a",
  },
  qualityVariant: {
    backgroundColor: "#2a5e5e",
  },
  speedVariant: {
    backgroundColor: "#3b5998",
  },
  fandomVariant: {
    backgroundColor: "#8a2be2",
  },
}));
